var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.55 3.11111C12.55 4.27705 9.96448 5.22222 6.775 5.22222C3.58555 5.22222 1 4.27705 1 3.11111M12.55 3.11111C12.55 1.94518 9.96448 1 6.775 1C3.58555 1 1 1.94518 1 3.11111M12.55 3.11111V7.81588C11.2674 8.20309 10.45 8.78884 10.45 9.44444M1 3.11111V15.7778C1 16.9437 3.58555 17.8889 6.775 17.8889C8.17111 17.8889 9.45155 17.7078 10.45 17.4064V9.44444M10.45 9.44444C10.45 10.6104 13.0355 11.5556 16.225 11.5556C19.4145 11.5556 22 10.6104 22 9.44444M10.45 9.44444C10.45 8.27851 13.0355 7.33333 16.225 7.33333C19.4145 7.33333 22 8.27851 22 9.44444M10.45 9.44444V17.8889C10.45 19.0549 13.0355 20 16.225 20C19.4145 20 22 19.0549 22 17.8889V9.44444M1 7.33333C1 8.4993 3.58555 9.44444 6.775 9.44444C8.17111 9.44444 9.45155 9.26331 10.45 8.96195M1 11.5556C1 12.7215 3.58555 13.6667 6.775 13.6667C8.17111 13.6667 9.45155 13.4855 10.45 13.1842M22 13.6667C22 14.8326 19.4145 15.7778 16.225 15.7778C13.0355 15.7778 10.45 14.8326 10.45 13.6667",
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.cd89d0dc5aa32298e9aa84de34ffd7c8.svg";
export { ForwardRef as ReactComponent };